export default __webpack_public_path__ + "static/media/dl.d9e32a85.svg";